export default "__VITE_ASSET__1cc20697__"